import {
  FaServer,
  FaUserFriends,
  FaMapMarkerAlt,
  FaClipboardList,
  FaBriefcaseMedical
} from "react-icons/fa";
import { IDashboard } from "../route.type";
import DashboardPage from "../../modules/dashboard/pages/dashboard.page";
import { AddProductPage } from "../../modules/product/pages/add-product.page";
import { AllProductsPage } from "../../modules/product/pages/all-products.page";
import AddLocationPage from "../../modules/location/pages/add-location.page";
import { AllLocationsPage } from "../../modules/location/pages/all-locations.page";
import { TransferPage } from "../../modules/stock-operation/pages/transfer.page";
import { InitialInventoryPage } from "../../modules/stock-operation/pages/initial-inventory.page";
import { DemandInventoryPage } from "../../modules/stock-operation/pages/demand-inventory.page";
import LocationInventoryPage from "../../modules/report/pages/location-inventory.page";
import AllOperationPage from "../../modules/report/pages/all-operation.page";
import { RegisterPage } from "../../modules/auth/pages/register.page";
import { UserListPage } from "../../modules/user/pages/user-list.page";
import DailyProductReportPage from "../../modules/report/pages/daily-product-report.page";
import MonthlyProductReportPage from "../../modules/report/pages/monthly-product-report.page";
import LocationOperationsPage from "../../modules/report/pages/location-operations.page";
import OperationDetailsPage from "../../modules/report/pages/all-operation-details.page";
import { PendingOperationPage } from "../../modules/stock-operation/pages/pending-operation.page";
import { AssignUserToLocationPage } from "../../modules/user/pages/assign-user-to-location.page";
import { EditProductPage } from "../../modules/product/pages/edit-product.page";
import ApprovalOperationDetailsPage from "../../modules/stock-operation/pages/approval-operation-details.page";
import { EditLocationPage } from "../../modules/location/pages/edit.location.page";
import { LogoComponent } from "../../branding/logo.component";
import { VendorSupplyPage } from "../../modules/stock-operation/pages/vendor-supply.page";
import { DetailProductsPage } from "../../modules/product/pages/detail-product.page";
import { EditTransferPage } from "../../modules/stock-operation/pages/edit-transfer.page";
import { AssignUserRolePage } from "../../modules/user/pages/assign-user-role.page";
import InventoryByDatePage from "../../modules/report/pages/inventory-by-date.page";
import { RemoveUserLocationPage } from "../../modules/user/pages/remove-user-location.page";
import { AdjustmentReportPage } from "../../modules/report/pages/adjustment-report.page";
import { DemanFulfillPage } from "../../modules/stock-operation/pages/deman-fulfill.page";
import { ChangePasswordPage } from "../../modules/auth/pages/change-password.page";
import { AnnualProductReportPage } from "../../modules/report/pages/annual-product-report.page";
import { UpdatePasswordPage } from "../../modules/auth/pages/update-password.page";
import { SingleProductMovementByDatePage } from "../../modules/report/pages/single-product-movement-by-date.page";
import { SingleProductMovementByLocationPage } from "../../modules/report/pages/single-product-movement-by-location.page";
import { AllNotificationComponent } from "../../modules/notification/component/all-notification.component";
import { LowStockPage } from "../../modules/dashboard/pages/low-stock.page";
import { ToBeExpiredPage } from "../../modules/dashboard/pages/to-be-expired.page";

export const superAdminDashboard: IDashboard = {
  dashboardName: "SUPERADMIN",
  logo: <LogoComponent />,
  pages: [
    {
      name: "Items To Be expired",
      link: "/super-admin/to-be-expired",
      content: <ToBeExpiredPage />
    },
    {
      name: "Low Stock Products",
      link: "/super-admin/low-stock",
      content: <LowStockPage />
    },
    {
      name: "All Notification",
      link: "/super-admin/notification-all",
      content: <AllNotificationComponent />
    },
    {
      name: "Dashboard",
      link: "/super-admin/dashboard",
      content: <DashboardPage />
    },

    {
      name: "Product Details",
      link: "/super-admin/product-details/:id",
      content: <DetailProductsPage />
    },
    {
      name: "Add Product",
      link: "/super-admin/product/add",
      content: <AddProductPage />
    },
    {
      name: "All Products",
      link: "/super-admin/all-products",
      content: <AllProductsPage />
    },
    {
      name: "Add Location",
      link: "/super-admin/location/create",
      content: <AddLocationPage />
    },
    {
      name: "All Locations",
      link: "/super-admin/location/summary",
      content: <AllLocationsPage />
    },
    {
      name: "Transfer Operation",
      link: "/super-admin/stock-operation/transfer/create",
      content: <TransferPage />
    },
    {
      name: "Edit Transfer Operation",
      link: "/super-admin/stock-operation/transfer/edit/:operationId",
      content: <EditTransferPage />
    },
    {
      name: "Pending Operation",
      link: "/super-admin/stock-operation/pending-operation",
      content: <PendingOperationPage />
    },
    {
      name: "Initial Inventory",
      link: "/super-admin/stock-operation/initial-inventory/crete",
      content: <InitialInventoryPage />
    },
    {
      name: "Vendor Supply",
      link: "/super-admin/stock-operation/vendor-supply/create",
      content: <VendorSupplyPage />
    },
    {
      name: "Demand Inventory",
      link: "/super-admin/stock-operation/demand/create",
      content: <DemandInventoryPage />
    },
    {
      name: "Location Inventory",
      link: "/super-admin/report/location-inventory",
      content: <LocationInventoryPage />
    },
    {
      name: "All Operation",
      link: "/super-admin/report/all-operation",
      content: <AllOperationPage />
    },
    {
      name: "Location Operations",
      link: "/super-admin/report/location-operations",
      content: <LocationOperationsPage />
    },
    {
      name: "Operation Details",
      link: "/super-admin/report/operation-details/:id",
      content: <OperationDetailsPage />
    },
    {
      name: "Approval Operation Details",
      link: "/super-admin/approval/operation-details",
      content: <ApprovalOperationDetailsPage />
    },
    {
      name: "Daily Product Report",
      link: "/super-admin/report/daily-product-report",
      content: <DailyProductReportPage />
    },
    {
      name: "Monthly Product Report",
      link: "/super-admin/report/monthly-product-report",
      content: <MonthlyProductReportPage />
    },
    {
      name: "Annual Product Prediction Report",
      link: "/super-admin/report/annual-product-report",
      content: <AnnualProductReportPage />
    },
    {
      name: "Register User",
      link: "/super-admin/register",
      content: <RegisterPage />
    },
    {
      name: "User List",
      link: "/super-admin/user-list",
      content: <UserListPage />
    },
    {
      name: "Assign User Location",
      link: "/super-admin/assign-user-to-location",
      content: <AssignUserToLocationPage />
    },
    {
      name: "Remove User Location",
      link: "/super-admin/remove-user-location",
      content: <RemoveUserLocationPage />
    },
    {
      name: "Edit Product",
      link: "/super-admin/product/edit/:id",
      content: <EditProductPage />
    },
    {
      name: "Edit Location",
      link: "/super-admin/location/edit/:id",
      content: <EditLocationPage />
    },
    {
      name: "Reset Password",
      link: "/super-admin/change-password",
      content: <ChangePasswordPage />
    },
    {
      name: "Demand Fulfill",
      link: "/super-admin/demand-fulfil/:id",
      content: <DemanFulfillPage />
    },
    {
      name: "Assign User Role",
      link: "/super-admin/assign-user-role",
      content: <AssignUserRolePage />
    },
    {
      name: "Inventory By Date",
      link: "/super-admin/report/previous-inventory",
      content: <InventoryByDatePage />
    },
    {
      name: "Adjustment Report",
      link: "/super-admin/report/adjustment-report",
      content: <AdjustmentReportPage />
    },
    {
      name: "Update Password",
      link: "/super-admin/update-password",
      content: <UpdatePasswordPage />
    },
    {
      name: "Single Product Movement (By Location)",
      link: "/super-admin/report/single-product-movement",
      content: <SingleProductMovementByLocationPage />
    },
    {
      name: "Single Product Movement (By Date)",
      link: "/super-admin/report/date-wise-product-movement",
      content: <SingleProductMovementByDatePage />
    }
  ],

  sidebar: [
    {
      name: "Dashboard",
      link: "/super-admin/dashboard",
      content: <DashboardPage />
    },
    {
      header: "Product",
      icon: FaBriefcaseMedical,
      pages: [
        {
          name: "Add Product",
          link: "/super-admin/product/add",
          content: <AddProductPage />
        },
        {
          name: "All Products",
          link: "/super-admin/all-products",
          content: <AllProductsPage />
        }
      ]
    },
    {
      header: "Location",
      icon: FaMapMarkerAlt,
      pages: [
        {
          name: "Add Location",
          link: "/super-admin/location/create",
          content: <AddLocationPage />
        },
        {
          name: "All Locations",
          link: "/super-admin/location/summary",
          content: <AllLocationsPage />
        }
      ]
    },
    {
      header: "Stock Operation",
      icon: FaServer,
      pages: [
        {
          name: "Transfer Operation",
          link: "/super-admin/stock-operation/transfer/create",
          content: <TransferPage />
        },
        {
          name: "Initial Inventory",
          link: "/super-admin/stock-operation/initial-inventory/crete",
          content: <InitialInventoryPage />
        },
        {
          name: "Vendor Supply",
          link: "/super-admin/stock-operation/vendor-supply/create",
          content: <VendorSupplyPage />
        },
        {
          name: "Demand Inventory",
          link: "/super-admin/stock-operation/demand/create",
          content: <DemandInventoryPage />
        },
        {
          name: "Pending Operation",
          link: "/super-admin/stock-operation/pending-operation",
          content: <PendingOperationPage />
        }
      ]
    },
    {
      header: "Report",
      icon: FaClipboardList,
      pages: [
        {
          name: "All Operation",
          link: "/super-admin/report/all-operation",
          content: <AllOperationPage />
        },
        {
          name: "Location Operations",
          link: "/super-admin/report/location-operations",
          content: <LocationOperationsPage />
        },
        {
          name: "Location Inventory",
          link: "/super-admin/report/location-inventory",
          content: <LocationInventoryPage />
        },
        {
          name: "Inventory By Date",
          link: "/super-admin/report/previous-inventory",
          content: <InventoryByDatePage />
        },
        {
          name: "Daily Product Report",
          link: "/super-admin/report/daily-product-report",
          content: <DailyProductReportPage />
        },
        {
          name: "Monthly Product Report",
          link: "/super-admin/report/monthly-product-report",
          content: <MonthlyProductReportPage />
        },
        {
          name: "Adjustment Report",
          link: "/super-admin/report/adjustment-report",
          content: <AdjustmentReportPage />
        },
        {
          name: "Annual Product Prediction Report",
          link: "/super-admin/report/annual-product-report",
          content: <AnnualProductReportPage />
        },
        {
          name: "Single Product Movement (By Location)",
          link: "/super-admin/report/single-product-movement",
          content: <SingleProductMovementByLocationPage />
        },
        {
          name: "Single Product Movement (By Date)",
          link: "/super-admin/report/date-wise-product-movement",
          content: <SingleProductMovementByDatePage />
        }
      ]
    },
    {
      header: "Users",
      icon: FaUserFriends,
      pages: [
        {
          name: "Register User",
          link: "/super-admin/register",
          content: <RegisterPage />
        },
        {
          name: "User List",
          link: "/super-admin/user-list",
          content: <UserListPage />
        },
        {
          name: "Assign User Location",
          link: "/super-admin/assign-user-to-location",
          content: <AssignUserToLocationPage />
        },
        {
          name: "Remove User Location",
          link: "/super-admin/remove-user-location",
          content: <RemoveUserLocationPage />
        },
        {
          name: "Assign User Role",
          link: "/super-admin/assign-user-role",
          content: <AssignUserRolePage />
        },
        {
          name: "Reset Password",
          link: "/super-admin/change-password",
          content: <ChangePasswordPage />
        }
      ]
    }
  ]
};
